import { useDialog } from '@negar/core';
import { useI18n } from 'vue-i18n';
import { computed, ComputedRef } from 'vue';
import { AgreementItem } from '@libs/api-reference';

import { ApproveAgreementDialog } from '@/modules/user';

export default function useUserDialogs() {
  const { add: addDialog } = useDialog();
  const { t } = useI18n();

  function openApproveAlgorithmAgreementDialog({
    agreement,
    onConfirmCallback,
  }: {
    agreement: ComputedRef<AgreementItem | undefined>;
    onConfirmCallback?: () => void;
  }) {
    addDialog({
      title: t('agreement.confirmAlgorithmAgreementTitle'),
      content: computed(() => ({
        component: ApproveAgreementDialog,
        props: {
          selectedAgreement: agreement.value,
          onConfirmCallback: onConfirmCallback,
        },
      })),
    });
  }

  return { openApproveAlgorithmAgreementDialog };
}
